import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { Http } from '@angular/http';
import CustomStore from 'devextreme/data/custom_store';
import { NTECH_API } from './../app.api';
import { GridConfig, calculaAlturaGrid, adicionaIconesGrid } from './../app.config';
import { DxDataGridModule, DxDataGridComponent } from 'devextreme-angular';
import { LocalidadeService } from '../localidade/localidade.service';

@Component({
  selector: 'ntc-bairro',
  templateUrl: './bairro.component.html',
  styleUrls: ['./bairro.component.css']
})
export class BairroComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;

  editOptionsGridBairro = null;
  colunasGridBairro = null;
  bairro = null;
  listaLocalidade = null;
  alturaGrid = null;

  showFilterRow = GridConfig.showFilterRow;
  currentFilter = GridConfig.currentFilter;
  showHeaderFilter = GridConfig.showHeaderFilter;
  columnChooser = GridConfig.columnChooser;
  groupPanel = GridConfig.groupPanel;
  searchPanel = GridConfig.searchPanel;
  exportGrid = GridConfig.exportGrid;

  constructor(
    @Inject(Http) http: Http,
    private localidadeService: LocalidadeService
  ) {

    this.bairro = new CustomStore({
      insert: function (values) {
        return http.post(`${NTECH_API}/bairro/`, values).toPromise();
      },
      remove: function (key) {
        return http.delete(`${NTECH_API}/bairro/${encodeURIComponent(key.Id)}`).toPromise();
      },
      update: function (key, values) {
        return http.put(`${NTECH_API}/bairro/${encodeURIComponent(key.Id)}`, Object.assign(key, values)).toPromise();
      },
      load: function (loadOptions: any) {
        return http.get(`${NTECH_API}/bairro/`)
            .toPromise()
            .then(response => response.json())
            .catch(error => { throw 'Erro ao carregar dados.' });
      }
    });

    this.colunasGridBairro = [
      {
        dataField: 'Id',
        dataType: 'string',
        caption: 'ID',
        editorOptions: { disabled: true }
      },
      {
        dataField: 'NomeBairro',
        dataType: 'string',
        caption: 'Nome do Bairro',
        validationRules: [{
          type: 'required',
          message: 'Nome do Bairro é obrigatório.'
        }]
      }
    ];

    this.editOptionsGridBairro = {
      mode: GridConfig.gridMode, // form
      allowUpdating: true,
      allowAdding: true,
      allowDeleting: true,
      popup: {
        title: 'Bairro',
        showTitle: true,
      }
    };

  }

  onCellPrepared(e) {
    adicionaIconesGrid(e);
  }

  ngOnInit() {
    this.alturaGrid = calculaAlturaGrid();

    this.localidadeService.getLocalidades().subscribe(localidades => {
      this.listaLocalidade = localidades;

      const selectLocalidade = {
        dataField: 'IdLocalidade',
        caption: 'Localidade',
        lookup: {
            dataSource: this.listaLocalidade,
            displayExpr: 'NomeLocalidade',
            valueExpr: 'Id'
        },
        validationRules: [{
          type: 'required',
          message: 'Localidade é obrigatória.'
        }]
      };

      this.colunasGridBairro.push(selectLocalidade);
    });
  }

  onToolbarPreparing(e) {
    const toolbarItems = e.toolbarOptions.items;

    // Adiciona um novo botao a Toolbar
    toolbarItems.push({
      location: 'after',
      widget: 'dxButton',
      options: {
          icon: 'refresh',
          onClick: this.refreshDataGrid.bind(this)
      }
    });
  }

  refreshDataGrid() {
    this.dataGrid.instance.refresh();
  }
}



// WEBPACK FOOTER //
// ./src/app/bairro/bairro.component.ts